export default __webpack_public_path__ + "static/media/photo4.d5413d8e.jpg";